import { render, staticRenderFns } from "./LeadsCardSuggestedPriceModal.vue?vue&type=template&id=37e644c7&scoped=true&"
import script from "./LeadsCardSuggestedPriceModal.vue?vue&type=script&lang=js&"
export * from "./LeadsCardSuggestedPriceModal.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardSuggestedPriceModal.vue?vue&type=style&index=0&id=37e644c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e644c7",
  null
  
)

export default component.exports